import { Controller } from "@hotwired/stimulus"

// Manages selection styling for inbox rows. Each row is itself a link
// (data-turbo-frame="inbox_action_detail"); this controller just keeps the
// "selected" highlight in sync as Turbo swaps the detail pane.
export default class extends Controller {
  static targets = ["row"]

  select(event) {
    const row = event.currentTarget.closest("[data-inbox-pane-target~='row']")
    if (row) this.markSelected(row)
  }

  markSelected(selectedRow) {
    this.rowTargets.forEach((row) => {
      const selected = row === selectedRow
      row.classList.toggle("ops-row--selected", selected)
      row.setAttribute("aria-selected", selected.toString())
    })
  }
}
